module.exports = {
  template: require('./users-create-container.pug')()
  controller: require('./users-create-container.ctrl')
}
